import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, Router } from '@angular/router';
import { OAuthService } from '@qaroni-app/auth/services/o-auth.service';

export const authenticationGuard: CanActivateFn = () => {
  const redirectTo = '/';

  const authService = inject(OAuthService);
  const router = inject(Router);

  if (authService.isAuth) {
    return true;
  }

  router.navigate([redirectTo]);

  return false;
};

export const oAuthCanMatch: CanMatchFn = () => {
  const redirectTo = '/';

  const authService = inject(OAuthService);

  const router = inject(Router);

  if (authService.isAuth) {
    return true;
  }

  router.navigate([redirectTo]);

  return false;
};
